import { connect } from 'react-redux';
import JobListView from './job_list_view';
import {
  getCurrentUser,
  getStaffJobListingsLoaded,
  getStaffJobListingsFilters,
  getStaffJobListingZipCode,
  getStaffJobListingsSearch,
  getEnumsForFormSelect,
  getStaffJobListingIds,
  getStaffTotalJobs,
  getStaffOrgJobIds,
  getStaffOrgJobsLoaded,
  getStaffTotalOrgJobs,
} from '../../../reducer';
import { listFilteredJobPostingsForStaff, listFilteredJobPostingsForStaffOrg, setStaffJobListingsSearch } from '../../../solve/actions';

const mapStateToProps = (state, { mode }) => {
  let jobs;
  let loaded;
  let totalJobs = 0;
  if (mode === 'all') {
    jobs = getStaffJobListingIds(state);
    totalJobs = +getStaffTotalJobs(state);
    loaded = getStaffJobListingsLoaded(state);
  } else {
    jobs = getStaffOrgJobIds(state);
    totalJobs = +getStaffTotalOrgJobs(state);
    loaded = getStaffOrgJobsLoaded(state);
  }

  return {
    currentUser: getCurrentUser(state),
    jobs,
    loaded,
    totalJobs,
    filters: getStaffJobListingsFilters(state),
    search: getStaffJobListingsSearch(state),
    zipCode: getStaffJobListingZipCode(state),
    distanceFilter: getEnumsForFormSelect(state, 'DistanceType'),
    jobTitleFilter: getEnumsForFormSelect(state, 'JobType'),
    industryTypeFilter: getEnumsForFormSelect(state, 'IndustryType'),
    shiftTitleFilter: getEnumsForFormSelect(state, 'ShiftType'),
    salaryFilter: getEnumsForFormSelect(state, 'PayLevelType'),
  };
};

const mapDispatchToProps = {
  listFilteredJobPostingsForStaff,
  listFilteredJobPostingsForStaffOrg,
  setSearch: setStaffJobListingsSearch,
};

const JobListContainer = connect(mapStateToProps, mapDispatchToProps)(JobListView);

export default JobListContainer;
